import { forwardRef, useCallback, useImperativeHandle, useRef, useState } from 'react';
import { useBoolean } from 'src/hooks/use-boolean';

import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import CustomDialog from './CustomDialog';

const ConfirmDialog = (_, ref) => {
  const dialog = useBoolean();
  const resolveRef = useRef();

  const [details, setDetails] = useState({ title: '', description: '' });

  useImperativeHandle(ref, () => ({
    open: ({ title, description }) => {
      dialog.onTrue();
      setDetails({ title, description });

      return new Promise((resolve) => {
        resolveRef.current = resolve;
      });
    },
  }));

  const handleConfirm = useCallback(() => {
    dialog.onFalse();
    resolveRef.current(true);
  }, [dialog]);

  const handleClose = useCallback(() => {
    dialog.onFalse();
    resolveRef.current(false);
  }, [dialog]);

  if (!dialog.value) return null;

  return (
    <CustomDialog open={dialog.value} onClose={handleClose} title={details.title}>
      <DialogContent>{details.description}</DialogContent>

      <DialogActions>
        <Button variant="outlined" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="contained" onClick={handleConfirm} autoFocus>
          Confirm
        </Button>
      </DialogActions>
    </CustomDialog>
  );
};

export default forwardRef(ConfirmDialog);
